import { Variant } from './utils';
import { getVariantsMeta } from './variant-display-prices';

export const updateSummaryOnQuantityChange = (): void => {
  const container = jQuery('#ProductSection-product-template-VET-updated');
  const quantity = document.querySelector('#Quantity');
  if (!container.length || !quantity) {
    return;
  }

  quantity.addEventListener('change', (): void => {
    const instance = container.data('instance');
    const variant = instance.variants.currentVariant;
    updateSummary(variant);
  });
};

export const updateSummary = (variant: Variant): void => {
  if (!variant) {
    return;
  }

  const meta = getVariantsMeta('#product-variants-meta');
  const variantNames = document.querySelectorAll('[data-variant-name]');
  variantNames.forEach((name) => (name.innerHTML = variant.title));

  const quantitySelector = document.querySelector('#Quantity');
  const quantity =
    quantitySelector instanceof HTMLInputElement ? quantitySelector.value : '1';

  const totalKits = document.querySelectorAll('[data-total-kits]');

  totalKits.forEach((totalKitsContainer) => {
    const kitsCount = meta[variant.id].number_of_packs * parseInt(quantity);
    if (isNaN(kitsCount)) {
      return;
    }

    totalKitsContainer.innerHTML = kitsCount.toString();
  });

  const totalPrice = document.querySelectorAll('[data-total-price]');
  totalPrice.forEach((name) => {
    name.innerHTML = window.Shopify.formatMoney(
      variant.price * parseInt(quantity),
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      window.theme.moneyFormat
    );
  });
};
